/**
 * Maintenance Mode — temporary global flag.
 *
 * When `MAINTENANCE_MODE = true`, every route except the static marketing
 * pages (landing, about, legal) is replaced by <MaintenanceMode />.
 *
 * To re-enable the app: set MAINTENANCE_MODE = false and ship.
 */
export const MAINTENANCE_MODE = false;

/** Latest expected end of maintenance window. */
export const MAINTENANCE_END_DATE = 'May 13, 2026';
